"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _moment = _interopRequireDefault(require("moment"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function Addon(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      submittedAt = _ref.submittedAt,
      status = _ref.status;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "applied-addons__list__addon"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "applied-addons__list__addon__header"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
    size: 20,
    name: icon,
    color: "monkey"
  }), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    heading5: true
  }, label)), /*#__PURE__*/_react.default.createElement("div", {
    className: "applied-addons__list__addon__info"
  }, status ? /*#__PURE__*/_react.default.createElement("div", {
    className: "applied-addons__list__addon__info__status"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, "Status"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, status)) : null, /*#__PURE__*/_react.default.createElement("div", {
    className: "applied-addons__list__addon__info__requested"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, "Requested"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, null, (0, _moment.default)(submittedAt, ['x', 'YYYY-MM-DDTHH:mm:ss.sssZ']).format('YYYY/MM/DD [at] H:mm a')))));
}

var _default = (0, _react.memo)(Addon);

exports.default = _default;